import { useSeasons } from "@/store/seasons";
import { Season } from "@busy-human/hxp-library";
import { computed } from "vue";

export function useSeasonFeature(feature: Season.Features) {
    const seasonStore = useSeasons();

    return computed(() => seasonStore.seasonFlagOverrides[feature] ?? seasonStore.current?.features?.[feature] ?? Season.FEATURE_DEFAULT_STATE);
}